module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-card"
  }, [_c('div', {
    staticClass: "accordion-card__title",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v(_vm._s(_vm.content.title)), _c('div', {
    staticClass: "accordion-card__title-arrow"
  }, [_c('Icon', {
    attrs: {
      "name": "dropdown"
    }
  })], 1)]), (_vm.show) ? _c('div', {
    staticClass: "accordion-card__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  }, [_vm._v(_vm._s(_vm.content.text))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56ab885a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/accordion/accordion-card/accordion-card.pug
// module id = 522
// module chunks = 1